// Contrato de API real (PR-02, ver docs/novas/doc_back/PR-02-followup-interno-e-contrato-externo-frontend.md):
// GET  /sinister-followup/:sinisterId/internal-notes
// POST /sinister-followup/internal-notes   { sinisterId, formattedNote }
//
// Notas internas são visíveis apenas para a equipe interna (Garantti) — diferente do
// FollowUp padrão (SinisterFollowUpService.ts, aba "Externo"), elas NÃO são enviadas por
// e-mail nem aparecem para os contatos externos cadastrados. Sem endpoints de contato:
// esse fluxo não tem noção de "contato"/notificação por e-mail.
import { Api } from "../axios-config";
import { SinisterSector } from "../../../../pages/creditRecovery/constants/sectorOptions";

export type GetSinisterInternalFollowupNotesResponse = {
	id: string;
	userId: string;
	userName: string;
	createdAt: Date;
	note: string;
	setor: SinisterSector;
};

const getSinisterInternalFollowupNotes = async (sinisterId: string): Promise<GetSinisterInternalFollowupNotesResponse[]> => {
	try {
		const { data } = await Api().get(`/sinister-followup/${sinisterId}/internal-notes`);

		if (data) return data;

		throw new Error("Erro ao carregar os followups internos.");
	} catch (error) {
		console.error(error);
		throw error;
	}
};

const addSinisterInternalFollowupNote = async (sinisterId: string, formattedNote: string): Promise<GetSinisterInternalFollowupNotesResponse> => {
	try {
		const { data } = await Api().post(`/sinister-followup/internal-notes`, {
			sinisterId,
			formattedNote,
		});

		if (data) return data;

		throw new Error("Erro ao adicionar followup interno.");
	} catch (error) {
		console.error(error);
		throw error;
	}
};

export const SinisterInternalFollowUpService = {
	getSinisterInternalFollowupNotes,
	addSinisterInternalFollowupNote,
};
